import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { IGroupEntityDTO } from '@modeso/types__aumico-lib-templates-be';
import Debug from 'debug';
import Swal from 'sweetalert2';
import { TemplatesProvider } from '../provider/templates.provider';

const debug = Debug('aumico:aumico-lib-templates-fe:BaseComponent');

@Component({
    selector: 'templates-base',
    template: `<ng-content></ng-content>`,
})
export class BaseComponent implements OnInit, OnDestroy {
    protected subscriptions = [];

    constructor(public templatesProvider: TemplatesProvider) {}

    ngOnInit(): void {
        this.subscriptions.push(
            // Groups
            this.templatesProvider.getGroupsResponse$().subscribe(this.groupsSuccessHandler),
            this.templatesProvider.getGroupsError$().subscribe(this.groupsErrorHandler),
            // Templates
            this.templatesProvider.getTemplatesResponse$().subscribe(this.templatesSuccessHandler),
            this.templatesProvider.getTemplatesError$().subscribe(this.templatesErrorHandler),
        );
    }

    fireSuccessMessage() {
        Swal.fire({
            icon: 'success',
            text: 'Done successfully',
            showConfirmButton: false,
            timer: 2000,
        });
    }

    fireErrorMessage() {
        Swal.fire({
            icon: 'error',
            text: 'Something went wrong',
        });
    }

    groupsSuccessHandler = (response: IGroupEntityDTO) => {
        if (response) {
            this.fireSuccessMessage();
            this.templatesProvider.removeGroupsResponse();
        }
    };

    groupsErrorHandler = (errorResponse: HttpErrorResponse) => {
        if (errorResponse) {
            this.fireErrorMessage();
            this.templatesProvider.removeGroupsError();
        }
    };

    templatesSuccessHandler = (response: IGroupEntityDTO) => {
        if (response) {
            this.fireSuccessMessage();
            this.templatesProvider.removeTemplatesResponse();
        }
    };

    templatesErrorHandler = (errorResponse: HttpErrorResponse) => {
        if (errorResponse) {
            this.fireErrorMessage();
            this.templatesProvider.removeTemplatesError();
        }
    };

    ngOnDestroy(): void {
        this.subscriptions.forEach((subscribe) => {
            subscribe.unsubscribe();
        });
    }
}
